var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgY(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 24C47 37.2548 36.4787 48 23.5 48C10.5213 48 0 37.2548 0 24C0 10.7452 10.5213 0 23.5 0C36.4787 0 47 10.7452 47 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3821 27.8585V19.1602C23.47 20.6132 25.8616 22.0168 28.6901 23.5301C26.3572 24.8239 23.47 26.2756 20.3821 27.8585ZM37.5911 14.8341C37.0584 14.1323 36.1506 13.586 35.184 13.4052C32.3432 12.8657 14.62 12.8642 11.7807 13.4052C11.0056 13.5505 10.3154 13.9017 9.72257 14.4473C7.22444 16.766 8.00723 29.2001 8.60938 31.2143C8.86259 32.0861 9.18992 32.7149 9.60216 33.1276C10.1333 33.6732 10.8605 34.0489 11.6958 34.2174C14.0349 34.7012 26.0855 34.9718 35.1346 34.2901C35.9683 34.1448 36.7063 33.757 37.2884 33.1881C39.5982 30.8787 39.4407 17.7463 37.5911 14.8341Z",
    fill: "#E9540D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/y.ddeaf98340501fd8ac1dadf838f01bd3.svg";
export { ForwardRef as ReactComponent };